import { render, staticRenderFns } from "./CmsCategories.vue?vue&type=template&id=6ff71b7c&"
import script from "./CmsCategories.vue?vue&type=script&lang=js&"
export * from "./CmsCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports